import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import toast, { Toaster } from "react-hot-toast";
import TagManager from "react-gtm-module";
import useDocumentTitle from "../../useDocumentTitle";
import { useHistory, Link, useLocation } from "react-router-dom";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import axios from "axios";
import useLocalePrefix from "../utils/useLocalePrefix";
import sendLeadToCrm from "../utils/sendLeadToCrm";
import ContactMx from "./ContactMx";

const Contact_form = () => {
  useDocumentTitle("Software de Punto de Venta Avanzado | INVU POS");

  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const history = useHistory();
  const prefix = useLocalePrefix();
  const location = useLocation();

  // Estados del formulario
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [name, setName] = useState("");
  const [isChecked, setIsChecked] = useState(false);

  // Estados de país y geolocalización
  const [country, setCountry] = useState("");
  const [countryRender, setCountryRender] = useState("");
  const [geoInfo, setGeoInfo] = useState({});
  const [loading, setLoading] = useState(true);
  const leadStatus = "Nuevo";

  const compareCountry = (a, b) =>
    a && b && a.toString().toLowerCase().replace(/\s/g, "") === b.toLowerCase();

  // GTM pageview
  // useEffect(() => {
  //   TagManager.dataLayer({
  //     dataLayer: { event: "pageview", path: location.pathname },
  //   });
  // }, [location.pathname]);

  // Obtener geoinfo
  const getGeoInfo = (fallbackCountry) => {
    axios
      .get("https://ipapi.co/json/")
      .then((res) => {
        const data = res.data;
        const detectedCountry = fallbackCountry || data.country_name;
        setGeoInfo(data);
        setCountry(detectedCountry);
        setCountryRender(detectedCountry);
      })
      .catch((err) => console.error("GeoInfo error:", err))
      .finally(() => setLoading(false));
  };

  // Lógica país (igual que modal)
  useEffect(() => {
    const loadCountry = () => {
      const savedCountry = localStorage.getItem("selectedCountry");

      if (savedCountry && savedCountry !== countryRender) {
        setCountry(savedCountry);
        setCountryRender(savedCountry);
        setLoading(false);
        return;
      }

      const knownCountries = [
        "mexico",
        "venezuela",
        "elsalvador",
        "costarica",
        "colombia",
        "guatemala",
        "republicadominicana",
        "unitedstates",
        "trinidadytobago",
        "panama",
      ];

      let langCountry = null;
      if (knownCountries.includes(lang.toLowerCase())) langCountry = lang;

      getGeoInfo(langCountry);
    };

    loadCountry();

    const handleStorageChange = (event) => {
      if (event.key === "selectedCountry" && event.newValue) {
        setCountry(event.newValue);
        setCountryRender(event.newValue);
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, [lang]);

  if (loading) return <div></div>;

  function generateUUID() {
    return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0,
        v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
  const hutkValue = generateUUID();

  // Info por país
  const countryInfo = {
    mexico: {
      phone: "+52 5534885178",
      email: "info@invupos.com",
      address:
        "Av. Marina Nacional 385, Verónica Anzures, Miguel Hidalgo, 11300 Ciudad de México, CDMX. Piso 6 Oficina 609.",
    },
    venezuela: {
      phone: "+58 4241847417 / +58 212 235 1863",
      email: "info@invupos.com",
      address: "Boleita Norte, Caracas. Venezuela",
    },
    elsalvador: {
      phone: "+503 6070 6217",
      email: "info@invupos.com",
      address:
        "Nivel 4 de la Torre Millennium, Alveare CoWorking. Oficina 24. 71 av, sur y paseo general escalón, San Salvador. El Salvador",
    },
    costarica: { phone: "", email: "info@invupos.com", address: "" },
    colombia: {
      phone: "+57 (316) 668-6283",
      email: "info@invupos.com",
      address: "Calle 95 No 14-45 / Oficina 502 INVU POS, Colombia",
    },
    guatemala: { phone: "", email: "info@invupos.com", address: "" },
    republicadominicana: { phone: "", email: "info@invupos.com", address: "Calle Girls Scout #4, Ensanche Naco, Santo Domingo, República Dominicana." },
    unitedstates: { phone: "", email: "info@invupos.com", address: "" },
    trinidadytobago: { phone: "", email: "info@invupos.com", address: "" },
    panama: {
      phone: "+507 201-8490",
      email: "info@invupos.com",
       address: "· Ciudad del Saber, Ancón; Calle Evelio Lara, Casa 133a, Ciudad de Panamá.",
       address2: "· Calle 50 y Calle 77, San Francisco, Edificio Banistmo, 3er piso de las oficinas de Pineapple Technologies."
    },
  };

  const handleSubmit = (evt) => {
    evt.preventDefault();
    sendLeadToCrm({
      firstName,
      lastName,
      email,
      phone,
      company: name,
      message,
      country: country,
      formName: "Formulario de Mercadeo",
    });
    const url =
      "https://api.hsforms.com/submissions/v3/integration/submit/3797225/be316fe8-ea4c-4aa2-ad2a-b5750f006e01";

    const data = {
      fields: [
        { name: "firstname", value: firstName },
        { name: "lastname", value: lastName },
        { name: "email", value: email },
        { name: "mobilephone", value: phone },
        { name: "name", value: name, objectTypeId: "COMPANY" },
        { name: "message", value: message },
        {
          name: "hs_lead_status",
          value: "Nuevo",
          objectTypeId: "CONTACT",
        },
      ],
      context: {
        hutk: hutkValue,
        ipAddress: geoInfo.ip,
        pageUri: "www.invupos.com",
        pageName: "Formulario de Mercadeo",
      },
    };

    const xhr = new XMLHttpRequest();
    xhr.open("POST", url);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
        toast.success("✅ Message sent! We will contact you soon.");
      } else if (xhr.readyState === 4) {
        toast.error("❌ Error sending form. Please try again.");
      }
    };
    xhr.send(JSON.stringify(data));
    clearForm();
  };

  const clearForm = () => {
    setFirstName("");
    setLastName("");
    setEmail("");
    setPhone("");
    setMessage("");
    setName("");
    setIsChecked(false);
  };

  const currentCountry = countryRender?.toLowerCase();
  const info = countryInfo[currentCountry] || {};

    // 🧩 👇 ESTA ES LA CLAVE:
  // Si el país es México, renderizamos SOLO <ContactMx /> y terminamos aquí
  if (compareCountry(countryRender, "Mexico")) {
    return <ContactMx />;
  }


  return (
    <section className="w-full flex justify-center py-16 bg-gray-50">
      <div className="flex flex-col lg:flex-row w-11/12 sm:w-5/6 max-w-6xl mx-auto gap-10">
        {/* 🌎 Nueva columna izquierda (tu diseño) */}
        <div className="lg:col-span-2 w-full lg:w-1/2">
          <div className="w-10 mb-4 h-10 rounded-full cursor-pointer bg-gradient-to-r from-pirPink to-pirOrange hover:from-pirLightBlue hover:to-pirPurple flex justify-center items-center"></div>

          <h2 className="max-w-md mb-6 font-sans text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl sm:leading-none xl:max-w-lg">
            {t("contacttittlenew")}
          </h2>

          <p className="text-lg max-w-sm text-gray-500 md:text-medium">
            {t("contactdescriptionnew")}
          </p>

          {/* Teléfono */}
          {info.phone && (
            <div className="mt-8">
              <div>
                <h3 className="text-lg font-semibold text-black">
                  {t("contactcelltittle")}
                </h3>
                <span className="block w-10 h-1 mt-1 bg-gradient-to-r from-pirPink to-pirOrange hover:from-pirLightBlue hover:to-pirPurple"></span>
                <p className="max-w-xs mt-4 text-lg text-gray-500">
                  {info.phone}
                </p>
              </div>
            </div>
          )}

          {/* Email */}
          <div className="mt-8">
            <div>
              <h3 className="text-lg font-semibold text-black">
                {t("contactemailtittle")}
              </h3>
              <span className="block w-10 h-1 mt-1 bg-gradient-to-r from-pirPink to-pirOrange hover:from-pirLightBlue hover:to-pirPurple"></span>
              <p className="max-w-xs mt-4 text-lg text-gray-500">
                {info.email || "info@invupos.com"}
              </p>
            </div>
          </div>

          {/* Dirección */}
          {info.address && (
            <div className="mt-8">
              <div>
                <h3 className="text-lg font-semibold text-black">
                  {t("contactlocationtittle")}
                </h3>
                <span className="block w-10 h-1 mt-1 bg-gradient-to-r from-pirPink to-pirOrange hover:from-pirLightBlue hover:to-pirPurple"></span>
                <p className="max-w-xl mt-4 text-lg text-gray-500">
                  {info.address} <br/>
                  {info.address2}
                </p>
              </div>
            </div>
          )}
        </div>

        {/* 📋 Columna derecha (formulario) */}
        <div className="w-full lg:w-1/2">
          <div className="flex flex-col w-full rounded-lg border border-gray-300 shadow-xl bg-white">
            <form onSubmit={handleSubmit}>
              <div className="p-6 border-b border-gray-200">
                <p className="font-semibold text-gray-800 text-xl">
                  {t("modaltrydemo")}
                </p>
              </div>

              <div className="flex flex-col px-6 py-5">
                {/* Campos */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-3">
                  <input
                    className="p-4 bg-white border border-gray-200 rounded shadow-sm"
                    placeholder={t("modalfirstname")}
                    required
                    type="text"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                  <input
                    className="p-4 bg-white border border-gray-200 rounded shadow-sm"
                    placeholder={t("modallastname")}
                    required
                    type="text"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                  />
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-3">
                  <input
                    className="p-4 bg-white border border-gray-200 rounded shadow-sm"
                    placeholder={t("modalemail")}
                    required
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <PhoneInput
                    className="w-full p-4 bg-white border border-gray-200 rounded shadow-sm"
                    placeholder={t("modalphone")}
                    defaultCountry={
                      compareCountry(countryRender, "Mexico")
                        ? "MX"
                        : compareCountry(countryRender, "Venezuela")
                        ? "VE"
                        : compareCountry(countryRender, "Elsalvador")
                        ? "SV"
                        : compareCountry(countryRender, "Costarica")
                        ? "CR"
                        : compareCountry(countryRender, "Peru")
                        ? "PE"
                        : compareCountry(countryRender, "Colombia")
                        ? "CO"
                        : compareCountry(countryRender, "Guatemala")
                        ? "GT"
                        : compareCountry(countryRender, "Republicadominicana")
                        ? "DO"
                        : compareCountry(countryRender, "Unitedstates")
                        ? "US"
                        : compareCountry(countryRender, "Trinidadytobago")
                        ? "TT"
                        : "PA"
                    }
                    required
                    value={phone}
                    onChange={(value) => setPhone(value)}
                  />
                </div>

                <input
                  className="w-full p-4 bg-white border border-gray-200 rounded shadow-sm mb-3"
                  placeholder={t("modalcompany")}
                  required
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />

                <textarea
                  placeholder={t("modalmessage")}
                  className="p-4 bg-white border border-gray-200 rounded shadow-sm h-36 mb-3"
                  required
                  value={message}
                  maxLength={250}
                  onChange={(e) => setMessage(e.target.value)}
                ></textarea>
                 <p className="text-xs text-gray-500 text-right">
                  {message.length}/250
                </p>

                {/* Checkbox */}
                <div className="text-left text-gray-600 flex items-center mb-5 mt-4">
                  <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={() => setIsChecked(!isChecked)}
                    required
                    className="w-5 h-5 text-blue-600 border-gray-200 rounded focus:ring-blue-500"
                  />
                  <label className="block ml-2 text-[14px] text-neutral-600">
                    {t("privacypolicytext1")}{" "}
                    <Link
                      className="underline font-bold text-indigo-600"
                      to={`${[prefix]}` + "/politicas-de-privacidad"}
                    >
                      {t("privacypolicytexthref2")}
                    </Link>{" "}
                    {t("privacypolicytext3")}
                  </label>
                </div>

                <button
                  type="submit"
                  className={`inline-flex items-center justify-center w-full px-8 py-3 border rounded hover:opacity-90 transition-all duration-200 ${
                    compareCountry(countryRender, "Mexico")
                      ? "bg-green-700 text-white" // 🇲🇽 Verde bandera
                      : compareCountry(countryRender, "Venezuela")
                      ? "bg-[#FED850] text-black" // 🇻🇪 Amarillo bandera
                      : compareCountry(countryRender, "Elsalvador")
                      ? "bg-[#0047AB] text-white" // 🇸🇻 Azul bandera
                      : compareCountry(countryRender, "Costarica")
                      ? "bg-[#002B7F] text-white" // 🇨🇷 Azul bandera
                      : compareCountry(countryRender, "Peru")
                      ? "bg-[#D91023] text-white" // peru
                      : compareCountry(countryRender, "Colombia")
                      ? "bg-[#FCD116] text-black" // 🇨🇴 Amarillo bandera
                      : compareCountry(countryRender, "Guatemala")
                      ? "bg-[#4997D0] text-white" // 🇬🇹 Azul celeste bandera
                      : compareCountry(countryRender, "Republicadominicana")
                      ? "bg-[#002D62] text-white" // 🇩🇴 Azul oscuro bandera
                      : compareCountry(countryRender, "Unitedstates")
                      ? "bg-[#3C3B6E] text-white" // 🇺🇸 Azul bandera
                      : compareCountry(countryRender, "Trinidadytobago")
                      ? "bg-[#CE1126] text-white" // 🇹🇹 Rojo bandera
                      : compareCountry(countryRender, "Panama")
                      ? "bg-[#005AA7] text-white" // 🇵🇦 Azul bandera
                      : "bg-indigo-600 text-white" // Default
                  }`}
                >
                  <span className="text-sm font-medium">{t("modalformbutton")}</span>
                </button>
              </div>
            </form>
            <Toaster position="bottom-center" reverseOrder={false} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact_form;
